import ejs from 'ejs/ejs'

class Shader {
  constructor (string, passes = 1) {
    this.string = string
    this.frag = ejs.render(this.string, { frag: true, vert: false })
    this.vert = ejs.render(this.string, { frag: false, vert: true })
    if (passes > 1) {
      this.passes = []
      for (let i = 0; i < (passes - 1); i++) {
        let pass = { frag: false, vert: false }
        pass['pass_' + (i + 1)] = true
        this.passes.push(ejs.render(this.string, pass))
      }
    }
  }
}

export default Shader
